// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","loader":"Button_loader__S3BdI","spin":"Button_spin__6FyKA"};